import React from "react";
import { withTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import Legend from "./components/Legend";
import InterventionItem from "./components/InterventionItem";
import InterventionsPriceTotals from "./components/InterventionsPriceTotals";

import "./index.scss";

const Interventions = ({ interventions, settings, t }) => {
  if (!interventions?.length) return null;

  const convertedInterventions =
    interventions
      ?.filter(
        intervention => intervention.check_in_remark_id || intervention.check_in_result_id || intervention.diagnose_overview_remark_id || intervention.question_result_id
      )
      .sort((a, b) => (a.ordering || 0) - (b.ordering || 0)) ?? [];

  const notConvertedInterventions = interventions?.filter(intervention => !convertedInterventions.includes(intervention)) ?? [];

  const localAndDmsInterventions = notConvertedInterventions
    .sort((a, b) => {
      if (a.is_local !== b.is_local) return a.is_local ? 1 : -1;
      if (a.created_on === b.created_on) return a.title.localeCompare(b.title);
      return a.created_on.localeCompare(b.created_on);
    })
    .sort((a, b) => (a.ordering || 0) - (b.ordering || 0));

  return (
    <div className="pdf-block pdf-block--avoid-break">
      <div className="interventions">
        <div className="interventions-header">
          <div className="interventions-header-title">
            <span className="interventions-icon">{<Icon name="wrench" />}</span>
            <span className="interventions-title-text">{t("cc_interventions").message || "Interventions"}</span>
          </div>
          <Legend t={t} />
        </div>
        <div className="interventions-table">
          <div className="interventions-section">
            {localAndDmsInterventions.map((intervention, index) => (
              <InterventionItem key={intervention.id} intervention={intervention} settings={settings} />
            ))}
          </div>

          {convertedInterventions.length > 0 && (
            <div className="interventions-section">
              {convertedInterventions.map((intervention, index) => (
                <InterventionItem key={intervention.id} intervention={intervention} settings={settings} />
              ))}
            </div>
          )}
        </div>
        <InterventionsPriceTotals interventions={interventions} settings={settings} />
      </div>
    </div>
  );
};

export default withTranslation()(Interventions);
